import * as d3 from "d3";

function getBorders (margin, index) {

    let up, down;

    up = margin.top;
    margin.graphs.map((d, i) => {
        if (i < index)
        {
            up = up + d + margin.offset;
        }
    })

    down = up + margin.graphs[index];
    return [down, up];
}

function getHeight (margin) {

    let height = margin.top + ((margin.graphs.length)-1) * margin.offset + margin.bottom;
    margin.graphs.map((d) => {height = height + d})
    return height;
}

function dateToYMD(date) {
    var d = date.getDate();
    var m = date.getMonth() + 1; //Month from 0 to 11
    var y = date.getFullYear();
    return '' + y + '-' + (m<=9 ? '0' + m : m) + '-' + (d <= 9 ? '0' + d : d);
}


export { getBorders, getHeight, dateToYMD };